import { render } from "./Communication.vue?vue&type=template&id=75e5446a&scoped=true"
import script from "./Communication.vue?vue&type=script&lang=js"
export * from "./Communication.vue?vue&type=script&lang=js"

import "./Communication.vue?vue&type=style&index=0&id=75e5446a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75e5446a"]])

export default __exports__